import styled from "@emotion/styled"
import Link from "components/link/Link"
import { body40, body50, bold, legend100, legend110 } from "css/text"
import getMediaQuery from "css/breakpoints"
import { useConsole } from "contexts/Console"
import { Icon } from "components/icon/Icon"
import { useDictionary } from "contexts/Dictionary"
import { useNavigation } from "contexts/Navigation"

const Subnavigation = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(var(--grid-col-unit) * 6 + var(--grid-gap) * 5);
  margin: 0 auto;
  max-width: 500px;

  ${getMediaQuery("m")} {
    
  }

  .shortcuts {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    padding-block: 3.75rem;
  }
`

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  margin-block-start: 3.1rem;

  > p {
    ${body40}
    color: rgb(var(--green));
    font-weight: 700;
    gap: 0.75rem;
    margin-block-end: .6rem;
  }

  a {
    text-decoration: none;
    color: rgb(var(--dark-grey));
    font-weight: 400;
    font-size: 1rem;
    width: fit-content;
    ${body40};

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        font-weight: 700;
      }
    }
    > svg {
      display: none;
    }
  }
`

const Shortcut = styled.a`
  ${bold}
  display: flex;
  text-decoration: none;
  color: currentColor;
  border: 1px solid rgb(var(--grey));
  border-radius: 50px;
  padding: 0.5rem 1rem;
  justify-content: center;
  transition: color 300ms;
  align-items: center;

  > svg {
    margin-inline-end: 0.5rem;
  }

  &:hover {
    @media (hover: hover) and (pointer: fine) {
      color: rgb(var(--green));
    }
  }
`

export default function Navigation(props) {
  const console = useConsole()
  const dictionary = useDictionary()
  const navigation = useNavigation()
  const actions = props.tools.map(item => item.action).filter(Boolean)
  const shortcuts = props.tools.map(item => item.shortcut).filter(Boolean)

  function onShortcutClick(e) {
    e.preventDefault()
    navigation.navigate(e.currentTarget.getAttribute("href"))
  }

  function onActionClick(e) {
    e.preventDefault()
    navigation.navigate(e.currentTarget.getAttribute("href"))
  }

  return (
    <Subnavigation>
      {/* <div className='shortcuts'>
        {shortcuts.map(shortcut => {
          return (
            <Shortcut onClick={onShortcutClick} href={shortcut.href} key={shortcut.label}>
              <Icon type={shortcut.href.includes("locator") ? "location" : "crown"} />
              <span>{shortcut.label}</span>
            </Shortcut>
          )
        })}
      </div> */}
      <Actions>
        <p>{dictionary.shortcuts()}</p>
        {actions.map(link => {
          return (
            <a onClick={onActionClick} href={navigation.localize(link.href)} key={link.label}>
              {link.label}
            </a>
          )
        })}
      </Actions>
    </Subnavigation>
  )
}
